import { Layout } from 'antd';
import Footer from './Footer';
import PublicHeader from './Headers/Public';

const { Content } = Layout;

const PublicLayout = ({ global, children }) => {
    if (!global) {
        return children;
    }

    return (
        <Layout className="public-layout">
            <Layout className="app-body">
                <PublicHeader />

                <Layout className="app-content-wrapper">
                    <Content className="app-content">{children}</Content>
                </Layout>

                <Footer />
            </Layout>
        </Layout>
    );
};

export default PublicLayout;